import { ClientAutocompleteControlInterface, CountryAutocompleteControlInterface } from '../../interfaces';

import { AutocompleteOptionInterface } from '../../components';
import { ClientAutocompleteItemInterface } from '../../widgets/client-autocomplete';

import { AutocompleteControl } from './autocomplete-control';

export class ClientAutocompleteControl extends AutocompleteControl {
    public clients: ClientAutocompleteItemInterface[];

    constructor(data: ClientAutocompleteControlInterface) {
        super(data);

        this.clients = data.clients;
    }

    setOptions(options: AutocompleteOptionInterface[]): void {
        this.options = options;
    }
}
